































import { HasTaskMixin } from 'mycorems-app-shared';
import isGranted from '../../auth/isGranted';
import eventBus from '../../messaging/event-bus';
import { SubscribedToAccount, UnsubscribedFromAccount } from '../../messaging/events';
import {
  Account, AccountSubscriberFilters, AccountSubscriber, QueryResult,
} from '../../types';
import accountRepository from '../account-repository';
import subscriberRepository from './client-subscriber-repository';

interface Data {
  accounts: Account[],
  searchedAccounts: Account[],
}

export default HasTaskMixin.extend({
  model: {
    event: 'change',
  },
  props: {
    parentId: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
    value: String,
    placeholder: {
      type: String,
      default: 'Select Account',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    wait: {
      type: Number,
      default: 500,
    },
  },
  data(): Data {
    return {
      accounts: [],
      searchedAccounts: [],
    };
  },
  computed: {
    noOptionsMessage(): string {
      return 'You are not subscribed to any accounts. You can search for an account by typing.';
    },
    optionAvailable(): boolean {
      if (!this.accounts.length) return false;
      const index = this.accounts.findIndex(a => a.id === this.value);
      return (index >= 0);
    },
    options(): Account[] {
      return (this.searchedAccounts.length) ? this.searchedAccounts : this.accounts;
    },
    filters(): AccountSubscriberFilters {
      return {
        userId: this.userId,
        limit: 20,
      };
    },
  },
  methods: {
    clear(): void {
      this.searchedAccounts = [];
      this.$emit('change', null);
    },
    filter(query, update) {
      update(() => {
        if (!query) {
          this.searchedAccounts = [];
          return;
        }
        this.search(query);
      });
    },
    search(name: string|null): void {
      if (!name) return;
      this.task = accountRepository.findAll(this.parentId, { name });
      this.task.then((result: QueryResult) => {
        this.searchedAccounts = result.items as Account[];
      });
    },
    determineOptionAvailability(): void {
      if (this.optionAvailable) return;
      if (!this.value) return;
      this.task = accountRepository.find(this.value);
      this.task.then((account: Account) => {
        this.accounts.unshift(account);
      });
    },
    load(): void {
      this.task = subscriberRepository.findByUser(this.filters);
      this.task.then((result: QueryResult) => {
        const accountSubscribers = result.items as AccountSubscriber[];
        this.accounts = accountSubscribers
          .map((accountSubscriber: AccountSubscriber) => accountSubscriber.account);
        this.determineOptionAvailability();
      });
    },
    onSubscribed(event: SubscribedToAccount): void {
      const index = this.accounts.findIndex(a => a.id === event.accountSubscriber.account.id);
      if (index >= 0) return;
      this.accounts.unshift(event.accountSubscriber.account);
    },
    onUnsubscribed(event: UnsubscribedFromAccount):void {
      const index = this.accounts.findIndex(a => a.id === event.accountSubscriber.account.id);
      if (index >= 0) {
        this.accounts.splice(index, 1);
      }
    },
    isGranted,
  },
  created(): void {
    this.load();
    eventBus.$on(SubscribedToAccount.eventName, this.onSubscribed);
    eventBus.$on(UnsubscribedFromAccount.eventName, this.onUnsubscribed);
  },
  beforeDestroy(): void {
    eventBus.$off(SubscribedToAccount.eventName, this.onSubscribed);
    eventBus.$off(UnsubscribedFromAccount.eventName, this.onUnsubscribed);
  },
});
